//export const API_BASE_URL = 'https://ipayapi.symboltransport.com/QRServer';
//export const API_BASE_URL = 'https://transport.ipay.ua:8096/QRServer';
export const API_BASE_URL = '/QRServer';
export const API_URL = API_BASE_URL+'/api/app/v1/monitoring/';
export const API_URL_AQ_PAY_UBQ = API_BASE_URL+'/api/app/v1/aqpay/urlbyqr/';
export const API_URL_AQ_PAY_PAYMENT = API_BASE_URL+'/api/app/v1/aqpay/payment/';
export const userLanguage = 'ua';